import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { LoyaltyMessagingModel } from 'models';

import { Level, liveAnnounce } from 'uitk-react-utils';
import { UitkToggleSwitch, UitkToggleSwitchAlign } from 'uitk-react-switch';

export interface LoyaltyMessagingProps extends LocalizedComponentProps {
  model: LoyaltyMessagingModel;
  routeStore?: RouteStore;
  searchCriteria?: SearchCriteriaModel;
  forceHistoryPushOnGoBack?: () => void;
}

const ToggleSwitchTracked = ClickTracker(UitkToggleSwitch);

@withLocalization
@inject('routeStore')
@observer
export class SWPToggle extends React.Component<LoyaltyMessagingProps> {
  private handleClick = () => {
    const { searchCriteria, routeStore, forceHistoryPushOnGoBack, l10n } = this.props;
    routeStore.updateSearch({ useRewards: searchCriteria.useRewards !== 'true' }, {}, true);

    if (forceHistoryPushOnGoBack && typeof forceHistoryPushOnGoBack === 'function') {
      forceHistoryPushOnGoBack();
    }

    if (searchCriteria?.useRewards === 'true') {
      setTimeout(() => liveAnnounce(l10n.formatText('common.pointsRemoved'), Level.POLITE), 500);
    } else {
      setTimeout(() => liveAnnounce(l10n.formatText('common.pointsApplied'), Level.POLITE), 500);
    }
  };

  public render() {
    const { model, searchCriteria } = this.props;

    if (!model || !model.saveWithPointsActionMessage || !model.saveWithPointsMessage || !searchCriteria) {
      return null;
    }

    return (
      <div data-stid="swp-toggle">
        <ToggleSwitchTracked
          id="swpToggle"
          checked={searchCriteria.useRewards === 'true'}
          onChange={this.handleClick}
          label={model.saveWithPointsMessage}
          labelClassName="uitk-type-300"
          align={UitkToggleSwitchAlign.LEFT}
          rffr={`swpToggle: ${model.saveWithPointsActionMessage}`}
        />
      </div>
    );
  }
}
